"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var AppMargins_1 = require("../../../app/components/AppMargins");
var DirectoryTable_1 = __importDefault(require("./DirectoryTable"));
var appMargins_1 = __importDefault(require("../../../app/components/AppMargins/appMargins"));
var MobilePanel_1 = __importDefault(require("./MobilePanel"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b;
    return core_1.createStyles({
        tableHeader: (_a = {
                display: 'flex',
                borderRadius: '10px 10px 0px 0px',
                backgroundColor: function (props) {
                    return !props.resultsCount ? 'white' : theme.palette.primary.main;
                },
                height: function (props) {
                    return !props.resultsCount ? '323px' : 'auto';
                },
                marginBottom: function (props) {
                    return !props.resultsCount ? theme.spacing(8) : theme.spacing(0);
                },
                '& th': {
                    border: 'none',
                    borderRadius: function (props) {
                        return !props.resultsCount ? '0px' : '8px 8px 0px 0px';
                    },
                    paddingLeft: theme.spacing(5),
                    verticalAlign: function (props) {
                        return !props.resultsCount ? 'top' : 'center';
                    },
                },
                '& tr': {
                    margin: function (props) {
                        return !props.resultsCount ? '0 auto' : '';
                    },
                },
                '& .MuiTableRow-root': {
                    height: 'auto',
                }
            },
            _a[theme.breakpoints.down('md')] = {
                height: 'auto',
                '& tr': {
                    border: 'none',
                },
            },
            _a),
        resultsHeaderText: {
            color: function (props) {
                return !props.resultsCount ? theme.palette.primary.main : '#C9CED6';
            },
        },
        tableWrapper: (_b = {
                width: '100%',
                margin: '0 auto',
                minHeight: theme.spacing(40),
                marginTop: theme.spacing(7.25)
            },
            _b[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(11),
            },
            _b[theme.breakpoints.up(1440)] = {
                width: theme.spacing(180),
            },
            _b),
        mobilePanel: {
            padding: theme.spacing(1.5),
        },
    });
});
/**
 * @component Holds the search results table and headers, as well as the mobile drawer.
 */
var DirectoryResults = function (_a) {
    var searchResults = _a.searchResults, pageCount = _a.pageCount, rowsPerPage = _a.rowsPerPage, resultsCount = _a.resultsCount, currentPage = _a.currentPage, changePageHandler = _a.changePageHandler, changeRowsPerPageHandler = _a.changeRowsPerPageHandler, query = _a.query, disablePagination = _a.disablePagination, rankOffset = _a.rankOffset, _b = _a.hideHeaderText, hideHeaderText = _b === void 0 ? false : _b;
    var _c = __read(react_i18next_1.useTranslation(), 1), t = _c[0];
    var appMargins = appMargins_1.default();
    var theme = core_1.useTheme();
    var classes = useStyles({ appMargins: appMargins, resultsCount: resultsCount });
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var _d = __read(react_1.useState(false), 2), isMobilePanelOpen = _d[0], setIsMobilePanelOpen = _d[1];
    var _e = __read(react_1.useState(), 2), urlInfo = _e[0], setUrlInfo = _e[1];
    return (react_1.default.createElement("div", { className: classes.tableWrapper },
        react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, { classes: { root: classes.tableHeader } },
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.Typography, { variant: isMobileView ? 'h5' : 'h3', className: classes.resultsHeaderText }, hideHeaderText ? (t('text.showing') + " " + resultsCount + " " + t('general.shortUrl')) : (react_1.default.createElement("span", null,
                                !!resultsCount &&
                                    t('text.showing') + " " + resultsCount + " " + (resultsCount > 1
                                        ? t('directory.linksFor')
                                        : t('directory.linkFor')) + " \u201C" + query + "\u201D",
                                !resultsCount &&
                                    t('directory.noLinkFound') + " \u201C" + query + "\u201D")))))))),
        !!resultsCount && (react_1.default.createElement(DirectoryTable_1.default, { searchResults: searchResults, pageCount: pageCount, rowsPerPage: rowsPerPage, currentPage: currentPage, changePageHandler: changePageHandler, changeRowsPerPageHandler: changeRowsPerPageHandler, resultsCount: resultsCount, setUrlInfo: setUrlInfo, setOpen: setIsMobilePanelOpen, disablePagination: disablePagination, rankOffset: rankOffset })),
        react_1.default.createElement(MobilePanel_1.default, { isOpen: isMobilePanelOpen, setOpen: setIsMobilePanelOpen, url: urlInfo })));
};
exports.default = DirectoryResults;
